import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { CreateMailboxRequest, MailboxWithCounts } from "@mailflare/shared";

import { queryKeys } from "@/lib/query-keys";

import { createMailbox, listMailboxes } from "./api";

export function useMailboxes() {
  return useQuery({ queryKey: queryKeys.mailboxes, queryFn: listMailboxes, staleTime: 30_000 });
}

/** Picks the first mailbox, or the one matching `preferredId` when present. */
export function selectMailbox(
  mailboxes: readonly MailboxWithCounts[],
  preferredId: string | undefined,
): MailboxWithCounts | undefined {
  if (preferredId !== undefined) {
    const match = mailboxes.find((mailbox) => mailbox.id === preferredId);
    if (match !== undefined) return match;
  }
  return mailboxes[0];
}

export function useCreateMailbox() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateMailboxRequest) => createMailbox(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mailboxes });
    },
  });
}
